<div class="agent-transactions-container">
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Agent Transactions</h1>
        <p>View and filter all agent invoice transactions with tax breakdown</p>
      </div>
    </div>
  </div>

  <div class="filters-section" [formGroup]="filterForm">
    <div class="filter-header">
      <h3><i class="fas fa-filter"></i> Filter Transactions</h3>
      <button type="button" class="clear-filters-btn" (click)="clearFilters()"
        [disabled]="!hasActiveFilters() || loading">
        <i class="fas fa-times"></i> Clear Filters
      </button>
    </div>

    <div class="filters-grid">
      <div class="filter-group">
        <label for="agentFilter">Agent</label>
        <select id="agentFilter" formControlName="agentId" class="filter-select">
          <option value="">All Agents</option>
          <option *ngFor="let agent of agents" [value]="agent.agentId">{{ agent.name }}</option>
        </select>
      </div>

      <div class="filter-group">
        <label for="fromDate">From Date</label>
        <input type="date" id="fromDate" formControlName="fromDate" class="filter-input">
      </div>

      <div class="filter-group">
        <label for="toDate">To Date</label>
        <input type="date" id="toDate" formControlName="toDate" class="filter-input">
      </div>

      <div class="filter-group">
        <label for="typeFilter">Type</label>
        <select id="typeFilter" formControlName="type" class="filter-select">
          <option *ngFor="let t of transactionTypes" [value]="t.value">{{ t.label }}</option>
        </select>
      </div>

      <div class="filter-actions">
        <button type="button" class="search-btn" (click)="onSearch()" [disabled]="loading">
          <i class="fas fa-search"></i> Search
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-message">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
  </div>

  <div class="grid-wrapper" [class.is-loading]="loading">
    <div *ngIf="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <span class="loading-text">Loading transactions...</span>
    </div>

    <div *ngIf="!loading && transactions.length > 0" class="results-summary">
      <p>Showing {{ pageIndex * pageSize + 1 }} to {{ Math.min((pageIndex + 1) * pageSize, totalCount) }} of
        {{ totalCount }} records</p>
    </div>

    <div *ngIf="transactions.length > 0" class="desktop-table-container">
      <div class="table-wrapper">
        <table class="transactions-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Agent</th>
              <th>Reference ID</th>
              <th>Type</th>
              <th class="text-right">Amount</th>
              <th class="text-right">CGST</th>
              <th class="text-right">SGST</th>
              <th class="text-right">Total</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tx of transactions" class="transaction-row"
              [class.row-invoiced]="tx.isInvoiced" [class.row-pending]="!tx.isInvoiced">
              <td class="date">{{ formatDate(tx.createdAt) }}</td>
              <td class="agent-name">{{ tx.agentName || '—' }}</td>
              <td class="reference-id">{{ tx.referenceId }}</td>
              <td class="type">{{ getTypeLabel(tx.type) }}</td>
              <td class="amount text-right">{{ formatCurrency(tx.amount) }}</td>
              <td class="amount text-right">{{ formatCurrency(tx.cgst) }}</td>
              <td class="amount text-right">{{ formatCurrency(tx.sgst) }}</td>
              <td class="amount text-right total">{{ formatCurrency(tx.totalAmount) }}</td>
              <td class="status">
                <span class="status-badge" [class.status-invoiced]="tx.isInvoiced"
                  [class.status-pending]="!tx.isInvoiced">
                  {{ tx.isInvoiced ? 'Invoiced' : 'Pending' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="!loading && transactions.length === 0" class="no-data-state">
      <div class="no-data-content">
        <i class="fas fa-receipt"></i>
        <h3>No Transactions Found</h3>
        <p>No agent transactions match your current filters.</p>
      </div>
    </div>

    <div *ngIf="transactions.length > 0" class="pagination-container">
      <app-pagination [page]="currentPage" [totalPages]="totalPages" [pageSize]="pageSize"
        (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
      </app-pagination>
    </div>
  </div>

  <div class="summary-footer" *ngIf="!loading || totalCount > 0">
    <div class="summary-card">
      <span class="summary-label">Overall Filtered Total</span>
      <span class="summary-value">{{ totalAmountSum | currency:'INR':'symbol-narrow':'1.2-2' }}</span>
      <span class="summary-hint">Across all {{ totalCount }} matching records</span>
    </div>
  </div>
</div>
